import config from '../../config';

export default {
  url: `${config.api.baseURL}/subpage`,
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/subpages/list.js